import { render, staticRenderFns } from "./bottom-policies.vue?vue&type=template&id=1cde435f&scoped=true"
import script from "./bottom-policies.vue?vue&type=script&lang=js"
export * from "./bottom-policies.vue?vue&type=script&lang=js"
import style0 from "./bottom-policies.vue?vue&type=style&index=0&id=1cde435f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cde435f",
  null
  
)

export default component.exports